import {
  isMobile,
  isMrBrainPage,
  trackEvent, sleep, isMockModeEnabled,
} from "../helpers";
import {initializeRecording, speakResponse, voiceIcons} from "./mic";
import { mockedChat } from "./mock";
import { scanUrl, parseBotResponse} from "./utils";
import {initSidebarHistory, prependDraftChatToHistory, updateNewChatTitle} from "./history-sidebar";
import {
  appendAnswer,
  appendAnswerPlaceholder,
  appendChatError, appendQuestion, disableRecordButton, enableRecordButton,
  focusTextInput,
  initChatContainer, scrollChatToBottom, scrollChatToLastAnswer
} from "./chat-container";
import {getChatId, getHasDraftChat, sendQuestion, setHasDraftChat} from "./api";
import { toggleBtnQaDuringChat } from "../qa";
let isBotLoading;

let currentSource;


jQuery(() => {
  if (!isMrBrainPage()) return;
  initPage();
});

function initPage() {

  jQuery('#mashbot-widget').hide();

  const questionFromUrl = scanUrl();

  currentSource =  scanUrl('source') || 'MrBrain';

  initSidebarHistory();

  if (questionFromUrl) {
    askBot(questionFromUrl);
  } else {
    focusTextInput();
  }

  initChatContainer(askBot);

  //starto già con una nuova chat
  prependDraftChatToHistory();

  registerVocalFunctions();
}

async function askBot(message) {
  if (isBotLoading) return;
  if (!message) throw new Error('no message')
  isBotLoading = true;
  //controlla se è una bozza
  const wasDraft = getHasDraftChat();

  // Traccia con il flag dinamico
  trackEvent("QUESTION_SUBMITTED", currentSource);
  // dopo il primo invio setto la source a MrBrain
  if (currentSource  !== 'MrBrain') {currentSource  = 'MrBrain'}
  startBotLoading();
  appendQuestion(message);
  appendAnswerPlaceholder();
  scrollChatToBottom();

  // Rimuovo SOLO rating non usati
  jQuery('.bot-rating').not('.disabled').remove();
  let response = null
  try {
    if (isMockModeEnabled) {
      await sleep(2000)
      response = parseBotResponse(mockedChat);
    } else {
      response = await sendQuestion(message)
    }
    appendAnswer(response);
    scrollChatToLastAnswer(24);

  } catch (err) {
    appendChatError('Si è verificato un errore. Aggiornare la pagina e riprovare');
    throw new Error(err);
  } finally {
    isBotLoading = false;
    endBotLoading();
    //se era una bozza vado a rimpiazzare l'html della bozza
    if (wasDraft) {
      setHasDraftChat(false);
      updateNewChatTitle(getChatId())
    }
  }
}

function startBotLoading() {
  const $input = jQuery('#chatbot-input');
  jQuery('.intro-message').hide();
  jQuery('#QA-banner').hide();
  toggleBtnQaDuringChat(true);
  $input.attr('disabled', true)
  $input.val('Richiesta in corso...');
  jQuery('#chatbot-submit').attr('disabled', true)
  jQuery('.home-chatbot-block__input').css('opacity', '.5')
  disableRecordButton()
}

function endBotLoading() {
  const $input = jQuery('#chatbot-input');
  $input.attr('disabled', false)
  $input.val('')
  focusTextInput();
  jQuery('#chatbot-submit').attr('disabled', false)
  jQuery('.home-chatbot-block__input').css('opacity', '1')
  enableRecordButton();
  jQuery('.home-chatbot-block__input').removeClass('ready')
}

function registerVocalFunctions() {
  //record domanda
  jQuery('#voice-record').on('click' , function () {
    initializeRecording();
  })

  //lettura risposta
  jQuery('body').on('click', '.btn-listen-msg', function() {
    const $btn = jQuery(this);
    const $icon = $btn.find('.listen-icon');
    const $text = $btn.find('.listen-text');
    const textToSpeak = $btn.data('text');
    const device = isMobile() ? 'mobile' : 'desktop';
    const config = voiceIcons[device]

    speakResponse(
      textToSpeak,
      () => {
        $icon.attr('src', voiceIcons[device].active,
          $text.text(config.activeText).addClass('text-pink-400 font-semibold')
        );
      },
      () => {
        $icon.attr('src', voiceIcons[device].default);
        $text.text(config.defaultText).removeClass('text-pink-400 font-semibold')
      }
    );
  });
}
